/*
 * Custom scripting by BUZZWOO!
 *
 * Artikelnummer-Suche fuer Ignite.
 *
 * Shopify Semantic Search (Spring '26) rankt exakte SKU-Treffer nach hinten:
 * "ASA-slun 23" liefert 174 Ergebnisse, der gesuchte Artikel steht auf Seite 7.
 * variants.sku:"ASA-SLUN 23" liefert ihn auf Position 1.
 *
 * Dieses Script schreibt Artikelnummer-Suchen beim Absenden auf die Feld-Query um
 * und holt automatisch die Originalsuche nach, falls die Feld-Query nichts findet.
 * Ohne JS bleibt das heutige Verhalten unveraendert.
 *
 * Kontext: .claude-bw/handoffs/armatron-semantic-search-crosscheck.md
 */
(() => {
  if (window.__bwSkuSearchBound) return;
  window.__bwSkuSearchBound = true;

  const PARAM_ORIG = 'bw_sku_q';   // traegt den Originalbegriff mit
  const PARAM_FB   = 'bw_sku_fb';  // Schleifenschutz

  // Artikelnummer-Muster, validiert gegen 1374 echte Armatron-SKUs (97,5 % Treffer,
  // Stand 2026-08-14, Quelle /collections/all/products.json). Null Falsch-Positive
  // unter den 1313 Woertern aller Produkttitel.
  // Bedingung: mindestens eine Ziffer im Begriff -> deutsche Bindestrich-Woerter
  // wie "Anti-Fingerprint" oder "Baby-Badewanne" matchen nicht.
  const SKU_RE = new RegExp(
    '^(?=[^0-9]*[0-9])(?:' +
      '[A-Za-z]{1,6}[-._ ][A-Za-z0-9]+(?:[-._ ][A-Za-z0-9]+)*' + // ASA-SLUN 23, AGW-11220401
      '|[A-Za-z]{1,6}\\d{2,}[A-Za-z]{0,4}(?:[.\\-_ xX][A-Za-z0-9]+)*' + // B275, B279BL, KB150-99, B295x16, B35639.MBLK
      '|\\d{3,}(?:[-.]\\d+)+' +                                          // 04000-2116-5
    ')$'
  );

  const looksLikeSku = (t) => SKU_RE.test(t.trim());
  const hasSyntax = (t) => /[:"*]|\sOR\s|\sAND\s/.test(t);

  // --- 1) Beim Absenden umschreiben -------------------------------------
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.getAttribute('role') !== 'search') return;

      const input = form.querySelector('input[name="q"]');
      if (!input) return;

      const term = input.value.trim();
      if (!term || hasSyntax(term) || !looksLikeSku(term)) return;

      // Originalbegriff mitgeben, damit die Ergebnisseite ihn anzeigen
      // und im Nullfall darauf zurueckfallen kann.
      let carrier = form.querySelector('input[name="' + PARAM_ORIG + '"]');
      if (!carrier) {
        carrier = document.createElement('input');
        carrier.type = 'hidden';
        carrier.name = PARAM_ORIG;
        form.appendChild(carrier);
      }
      carrier.value = term;

      input.value = 'variants.sku:"' + term.replace(/"/g, '') + '"';

      // predictive-search.js bricht den Submit ab, wenn ein Dropdown-Eintrag
      // aria-selected ist -- dann darf die Feld-Query-Syntax nicht im Feld
      // stehen bleiben. Beim echten Submit ist die Seite weg, bevor das feuert.
      setTimeout(() => { input.value = term; });
    },
    true // Capture: vor den Theme-Handlern
  );

  // --- 2) Auf der Ergebnisseite: Anzeige + Nullfall-Netz ----------------
  const onResults = () => {
    const url = new URL(window.location.href);
    const orig = url.searchParams.get(PARAM_ORIG);
    if (!orig) return;

    // a) Ueberall den menschlichen Begriff zeigen, nicht die Feld-Query:
    //    Suchfelder, H1 ("1 Ergebnis fuer ... gefunden"), Statuszeilen, Tab-Titel.
    document
      .querySelectorAll('form[role="search"] input[name="q"]')
      .forEach((i) => { i.value = orig; });

    const fieldQ = url.searchParams.get('q');
    if (fieldQ && fieldQ !== orig) {
      const swap = (s) => s.split(fieldQ).join(orig);
      // Textknoten statt fester Selektoren: Ignite rendert die Trefferzeile u. a.
      // als <p class="h2"> in .search-results-title, nicht als h1.
      const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue.includes(fieldQ)) node.nodeValue = swap(node.nodeValue);
      }
      if (document.title.includes(fieldQ)) document.title = swap(document.title);
    }

    // b) Nullfall -> einmalig die Originalsuche nachholen.
    if (url.searchParams.get(PARAM_FB) === '1') return;

    // ACHTUNG: id="product-grid" existiert doppelt (div + ul). Das ul ist gemeint.
    const grid = document.querySelector('ul#product-grid');
    const isEmpty =
      document.querySelector('.template-search--empty') !== null ||
      !grid ||
      grid.querySelector('.grid__item') === null;
    if (!isEmpty) return;

    const back = new URL(url);
    back.searchParams.set('q', orig);
    back.searchParams.delete(PARAM_ORIG);
    back.searchParams.set(PARAM_FB, '1');
    window.location.replace(back.toString());
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onResults);
  } else {
    onResults();
  }
})();
